(function () {
  if (window.otpLocationSettingsInitialized) return;
  window.otpLocationSettingsInitialized = true;

  var OTP_LOCATION_CONFIG = {
    storefronts: {
      us: {
        baseUrl: "https://us.olivetreepeople.com",
        defaultCountry: "US",
        defaultLanguage: "en",
        languages: {
          en: { label: "English", prefix: "" },
          es: { label: "Espanol", prefix: "/es" },
        },
      },
      ca: {
        baseUrl: "https://ca.olivetreepeople.com",
        defaultCountry: "CA",
        defaultLanguage: "en",
        languages: {
          en: { label: "English", prefix: "" },
          fr: { label: "French", prefix: "/fr" },
        },
      },
      eu: {
        baseUrl: "https://olivetreepeople.com",
        defaultCountry: "DE",
        defaultLanguage: "de",
        languages: {
          de: { label: "Deutsch", prefix: "" },
          en: { label: "English", prefix: "/en" },
          fr: { label: "French", prefix: "/fr" },
          nl: { label: "Dutch", prefix: "/nl" },
        },
      },
    },
    countries: {
      US: {
        name: "United States",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "en",
        languages: ["en", "es"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            {
              type: "pricedShippingMethod",
              method: "Economy",
              amountLabel: "$7 USD",
            },
            { type: "freeShippingThreshold", amountLabel: "$50 USD" },
            {
              type: "flatShippingMethod",
              method: "Express",
              amountLabel: "$30 USD",
            },
          ],
        },
      },
      CA: {
        name: "Canada",
        currency: "CAD",
        storefront: "ca",
        defaultLanguage: "en",
        languages: ["en", "fr"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            {
              type: "flatShippingMethodWithDuration",
              method: "Express",
              duration: "1-2",
              amountLabel: "$40 CAD",
            },
            {
              type: "freeShippingThresholdWithDuration",
              method: "Standard",
              amountLabel: "$70 CAD",
              duration: "3-9",
            },
          ],
        },
      },
      MX: {
        name: "Mexico",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "es",
        languages: ["es", "en"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
      CR: {
        name: "Costa Rica",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "es",
        languages: ["es", "en"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
      DE: {
        name: "Germany",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "de",
        languages: ["de", "en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€5.95" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      AT: {
        name: "Austria",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "de",
        languages: ["de", "en"],
        delivery: {
          lines: [
            { type: "flatShippingFee", amountLabel: "€12.50" },
            { type: "freeShippingThreshold", amountLabel: "€45" },
          ],
        },
      },
      CH: {
        name: "Switzerland",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "de",
        languages: ["de", "en"],
        delivery: {
          lines: [
            { type: "flatShippingFee", amountLabel: "€12.50" },
            { type: "freeShippingThreshold", amountLabel: "€45" },
          ],
        },
      },
      BE: {
        name: "Belgium",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en", "fr", "nl"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      BG: {
        name: "Bulgaria",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      HR: {
        name: "Croatia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      CY: {
        name: "Cyprus",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            {
              type: "standardUnderThreshold",
              amountLabel: "€14.90",
              thresholdLabel: "€45",
            },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      CZ: {
        name: "Czechia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      DK: {
        name: "Denmark",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      EE: {
        name: "Estonia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      FI: {
        name: "Finland",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      FR: {
        name: "France",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "fr",
        languages: ["fr", "en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      GR: {
        name: "Greece",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      HU: {
        name: "Hungary",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      IE: {
        name: "Ireland",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      IT: {
        name: "Italy",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      LV: {
        name: "Latvia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      LI: {
        name: "Liechtenstein",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "de",
        languages: ["de", "en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      LT: {
        name: "Lithuania",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      LU: {
        name: "Luxembourg",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "fr",
        languages: ["fr", "de", "en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      MT: {
        name: "Malta",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      NL: {
        name: "Netherlands",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "nl",
        languages: ["nl", "en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      PL: {
        name: "Poland",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      PT: {
        name: "Portugal",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      RO: {
        name: "Romania",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      SK: {
        name: "Slovakia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      SI: {
        name: "Slovenia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      ES: {
        name: "Spain",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      SE: {
        name: "Sweden",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      UA: {
        name: "Ukraine",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      BA: {
        name: "Bosnia & Herzegovina",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€16.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      NO: {
        name: "Norway",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€16.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      IS: {
        name: "Iceland",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€16.90" },
          ],
        },
      },
      AU: {
        name: "Australia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€49.90" },
          ],
        },
      },
      NZ: {
        name: "New Zealand",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€49.90" },
          ],
        },
      },
      TR: {
        name: "Türkiye",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€29.90" },
          ],
        },
      },
      DZ: {
        name: "Algeria",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "fr",
        languages: ["fr", "en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€26.50" },
          ],
        },
      },
      EG: {
        name: "Egypt",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€26.50" },
          ],
        },
      },
      MA: {
        name: "Morocco",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "fr",
        languages: ["fr", "en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€26.50" },
          ],
        },
      },
      GB: {
        name: "United Kingdom",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€14.90" },
            { type: "freeStandardThreshold", amountLabel: "€45" },
          ],
        },
      },
      IO: {
        name: "British Indian Ocean Territory",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      AZ: {
        name: "Azerbaijan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      BD: {
        name: "Bangladesh",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      BT: {
        name: "Bhutan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      BN: {
        name: "Brunei",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      CN: {
        name: "China",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      HK: {
        name: "Hong Kong SAR",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      IN: {
        name: "India",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      ID: {
        name: "Indonesia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      IL: {
        name: "Israel",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      JP: {
        name: "Japan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      JO: {
        name: "Jordan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      KW: {
        name: "Kuwait",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      KG: {
        name: "Kyrgyzstan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      LA: {
        name: "Laos",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      MY: {
        name: "Malaysia",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      MV: {
        name: "Maldives",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      NP: {
        name: "Nepal",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      PS: {
        name: "Palestinian Territories",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      PH: {
        name: "Philippines",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      QA: {
        name: "Qatar",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      SG: {
        name: "Singapore",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      KR: {
        name: "South Korea",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      LK: {
        name: "Sri Lanka",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      TW: {
        name: "Taiwan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      TJ: {
        name: "Tajikistan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      TH: {
        name: "Thailand",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      TM: {
        name: "Turkmenistan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      AE: {
        name: "United Arab Emirates",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      UZ: {
        name: "Uzbekistan",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      VN: {
        name: "Vietnam",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      YE: {
        name: "Yemen",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      CX: {
        name: "Christmas Island",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      CC: {
        name: "Cocos (Keeling) Islands",
        currency: "EUR",
        storefront: "eu",
        defaultLanguage: "en",
        languages: ["en"],
        delivery: {
          lines: [
            { type: "dutiesIncluded" },
            { type: "flatShippingFee", amountLabel: "€39.00" },
          ],
        },
      },
      AR: {
        name: "Argentina",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "es",
        languages: ["es", "en"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
      BR: {
        name: "Brazil",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "en",
        languages: ["en", "es"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
      CL: {
        name: "Chile",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "es",
        languages: ["es", "en"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
      PE: {
        name: "Peru",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "es",
        languages: ["es", "en"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
      UY: {
        name: "Uruguay",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "es",
        languages: ["es", "en"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
      VE: {
        name: "Venezuela",
        currency: "USD",
        storefront: "us",
        defaultLanguage: "es",
        languages: ["es", "en"],
        delivery: {
          lines: [
            { type: "dutiesCalculatedAtCheckout" },
            { type: "flatShippingFee", amountLabel: "$10.90 USD" },
          ],
        },
      },
    },
    groups: [
      {
        label: "Americas",
        countries: ["US", "CA", "MX", "CR", "AR", "BR", "CL", "PE", "UY", "VE"],
      },
      {
        label: "Europe",
        countries: [
          "DE",
          "AT",
          "CH",
          "BE",
          "BG",
          "HR",
          "CY",
          "CZ",
          "DK",
          "EE",
          "FI",
          "FR",
          "GR",
          "HU",
          "IE",
          "IT",
          "LV",
          "LI",
          "LT",
          "LU",
          "MT",
          "NL",
          "PL",
          "PT",
          "RO",
          "SK",
          "SI",
          "ES",
          "SE",
          "UA",
          "BA",
          "NO",
          "IS",
          "GB",
        ],
      },
      { label: "North Africa", countries: ["DZ", "EG", "MA"] },
      {
        label: "Middle East",
        countries: ["IL", "JO", "KW", "PS", "QA", "TR", "AE", "YE"],
      },
      {
        label: "Asia",
        countries: [
          "AZ",
          "BD",
          "BT",
          "BN",
          "CN",
          "HK",
          "IN",
          "ID",
          "JP",
          "KG",
          "LA",
          "MY",
          "MV",
          "NP",
          "PH",
          "SG",
          "KR",
          "LK",
          "TW",
          "TJ",
          "TH",
          "TM",
          "UZ",
          "VN",
        ],
      },
      { label: "Oceania", countries: ["AU", "NZ", "CX", "CC"] },
      { label: "International", countries: ["IO"] },
    ],
    messages: {
      en: {
        locationSettings: "Location settings",
        closeLocationSettings: "Close location settings",
        locationSummary: "Your location is set to {selection}",
        destinationCountry: "Destination country",
        save: "Save",
        continueShopping: "Continue shopping",
        changeShippingCountry: "Change shipping country",
        welcome: "Welcome to Olive Tree People",
        shoppingIn: "You're shopping in {country}",
        dutiesIncluded: "Duties and taxes are included.",
        dutiesCalculatedAtCheckout:
          "Duties and taxes are calculated at checkout.",
        standardUnderThreshold:
          "Standard shipping {amount} for orders under {threshold}",
        standardRatesStartingAt: "Standard rates starting at {amount}",
        freeStandardThreshold: "Free standard shipping on orders over {amount}",
        flatShippingFee: "Shipping is {amount}",
        freeExpressThreshold: "Free express shipping on orders over {amount}",
        freeShippingThreshold: "Free shipping on orders {amount} and up",
        pricedShippingMethod: "{method} Shipping {amount}",
        flatShippingMethod: "{method} Shipping is available for {amount}",
        flatShippingMethodWithDuration:
          "{method} Shipping {amount} - {duration} business days",
        freeShippingThresholdWithDuration:
          "{method} Shipping is free on orders {amount} and up - {duration} business days",
        returnPolicy:
          "365-day returns for Retail customers",
      },
      es: {
        locationSettings: "Configuracion de ubicacion",
        closeLocationSettings: "Cerrar configuracion de ubicacion",
        locationSummary: "Tu ubicacion esta configurada como {selection}",
        destinationCountry: "Pais de destino",
        save: "Guardar",
        continueShopping: "Continuar comprando",
        changeShippingCountry: "Cambiar pais de envio",
        welcome: "Te damos la bienvenida a Olive Tree People",
        shoppingIn: "Estas comprando en {country}",
        dutiesIncluded: "Los aranceles e impuestos estan incluidos.",
        dutiesCalculatedAtCheckout:
          "Los aranceles e impuestos se calculan al finalizar la compra.",
        standardUnderThreshold:
          "Envio estandar {amount} para pedidos inferiores a {threshold}",
        standardRatesStartingAt: "Tarifas estandar desde {amount}",
        freeStandardThreshold:
          "Envio estandar gratis en pedidos superiores a {amount}",
        flatShippingFee: "El envio cuesta {amount}",
        freeExpressThreshold:
          "Envio express gratis en pedidos superiores a {amount}",
        freeShippingThreshold: "Envio gratis en pedidos de {amount} o mas",
        pricedShippingMethod: "{method} Shipping {amount}",
        flatShippingMethod: "{method} Shipping disponible por {amount}",
        returnPolicy:
          "365 dias de devoluciones para clientes minoristas, 60 dias para consultoras de belleza sin agua",
      },
      fr: {
        locationSettings: "Parametres de localisation",
        closeLocationSettings: "Fermer les parametres de localisation",
        locationSummary: "Votre localisation est definie sur {selection}",
        destinationCountry: "Pays de destination",
        save: "Enregistrer",
        continueShopping: "Continuer vos achats",
        changeShippingCountry: "Changer le pays de livraison",
        welcome: "Bienvenue chez Olive Tree People",
        shoppingIn: "Vous magasinez en {country}",
        dutiesIncluded: "Les droits et taxes sont inclus.",
        dutiesCalculatedAtCheckout:
          "Les droits et taxes sont calcules au paiement.",
        standardUnderThreshold:
          "Livraison standard {amount} pour les commandes inferieures a {threshold}",
        standardRatesStartingAt: "Tarifs standard a partir de {amount}",
        freeStandardThreshold:
          "Livraison standard gratuite pour les commandes superieures a {amount}",
        flatShippingFee: "La livraison coute {amount}",
        freeExpressThreshold:
          "Livraison express gratuite pour les commandes superieures a {amount}",
        flatShippingMethodWithDuration:
          "Livraison {method} {amount} - {duration} jours ouvrables",
        freeShippingThresholdWithDuration:
          "Livraison {method} gratuite pour les commandes de {amount} et plus - {duration} jours ouvrables",
        returnPolicy:
          "Retours sous 365 jours pour les clients particuliers, 60 jours pour les conseillers beaute sans eau",
      },
      de: {
        locationSettings: "Standorteinstellungen",
        closeLocationSettings: "Standorteinstellungen schliessen",
        locationSummary: "Dein Standort ist auf {selection} eingestellt",
        destinationCountry: "Zielland",
        save: "Speichern",
        continueShopping: "Weiter einkaufen",
        changeShippingCountry: "Lieferland aendern",
        welcome: "Willkommen bei Olive Tree People",
        shoppingIn: "Du kaufst in {country} ein",
        dutiesIncluded: "Zolle und Steuern sind enthalten.",
        dutiesCalculatedAtCheckout:
          "Zoelle und Steuern werden beim Checkout berechnet.",
        standardUnderThreshold:
          "Standardversand {amount} fuer Bestellungen unter {threshold}",
        standardRatesStartingAt: "Standardtarife ab {amount}",
        freeStandardThreshold: "Kostenloser Standardversand ab {amount}",
        flatShippingFee: "Der Versand kostet {amount}",
        freeExpressThreshold: "Kostenloser Expressversand ab {amount}",
        freeShippingThreshold: "Kostenloser Versand ab {amount}",
        returnPolicy:
          "365 Tage Rueckgaberecht fuer Einzelhandelskunden, 60 Tage fuer Berater fuer Wasserlose Schoenheit",
      },
      nl: {
        locationSettings: "Locatie-instellingen",
        closeLocationSettings: "Locatie-instellingen sluiten",
        locationSummary: "Je locatie is ingesteld op {selection}",
        destinationCountry: "Bestemmingsland",
        save: "Opslaan",
        continueShopping: "Verder winkelen",
        changeShippingCountry: "Verzendland wijzigen",
        welcome: "Welkom bij Olive Tree People",
        shoppingIn: "Je winkelt in {country}",
        dutiesIncluded: "Invoerrechten en belastingen zijn inbegrepen.",
        dutiesCalculatedAtCheckout:
          "Invoerrechten en belastingen worden berekend bij het afrekenen.",
        standardUnderThreshold:
          "Standaardverzending {amount} voor bestellingen onder {threshold}",
        standardRatesStartingAt: "Standaardtarieven vanaf {amount}",
        freeStandardThreshold:
          "Gratis standaardverzending bij bestellingen boven {amount}",
        flatShippingFee: "Verzending kost {amount}",
        freeExpressThreshold:
          "Gratis expressverzending bij bestellingen boven {amount}",
        returnPolicy:
          "365 dagen retourrecht voor retailklanten, 60 dagen voor waterloze beauty consultants",
      },
    },
  };

  window.OTP_LOCATION_CONFIG =
    window.OTP_LOCATION_CONFIG || OTP_LOCATION_CONFIG;

  var config = window.OTP_LOCATION_CONFIG;

  var MULTI_LANG_SELECTOR = {
    US: ["en", "es"],
    CA: ["en", "fr"],
    BE: ["fr", "nl"],
  };
  var activeModal = null;
  var eventsBound = false;
  var returnFocusTo = null;
  var STORAGE_KEYS = {
    acknowledgedArrival: "otpLocationArrivalAcknowledged",
    destinationCountry: "otpDestinationCountry",
    language: "otpLanguage",
    legacyLanguage: "otpLang",
    pendingArrival: "otpLocationPendingArrival",
  };
  var TRANSFER_PARAMS = ["otp_country", "otp_lang", "otp_location_saved"];

  function getComponent(node) {
    return node ? node.closest(".otp-location-settings") : null;
  }

  function getModal(node) {
    return node ? node.closest("[data-otp-location-modal]") : null;
  }

  function getComponentModal(component) {
    if (!component) return null;
    if (component.otpLocationModal) return component.otpLocationModal;

    var modal = component.querySelector("[data-otp-location-modal]");
    if (modal) {
      component.otpLocationModal = modal;
      modal.otpLocationComponent = component;
    }

    return modal;
  }

  function getBrowserStorage(storageName) {
    try {
      return window[storageName] || null;
    } catch (e) {
      return null;
    }
  }

  function getStoredItem(storageName, key) {
    var storage = getBrowserStorage(storageName);
    if (!storage) return "";

    try {
      return storage.getItem(key) || "";
    } catch (e) {
      return "";
    }
  }

  function setStoredItem(storageName, key, value) {
    var storage = getBrowserStorage(storageName);
    if (!storage) return;

    try {
      storage.setItem(key, value);
    } catch (e) {}
  }

  function removeStoredItem(storageName, key) {
    var storage = getBrowserStorage(storageName);
    if (!storage) return;

    try {
      storage.removeItem(key);
    } catch (e) {}
  }

  function getCookie(name) {
    var namePrefix = encodeURIComponent(name) + "=";
    var cookies = (document.cookie || "").split(";");

    for (var i = 0; i < cookies.length; i += 1) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf(namePrefix) === 0) {
        return decodeURIComponent(cookie.substring(namePrefix.length));
      }
    }

    return "";
  }

  function setCookie(name, value, maxAgeDays) {
    var maxAge = Math.max(1, maxAgeDays || 180) * 24 * 60 * 60;

    try {
      document.cookie =
        encodeURIComponent(name) +
        "=" +
        encodeURIComponent(value) +
        "; max-age=" +
        maxAge +
        "; path=/; SameSite=Lax";
    } catch (e) {}
  }

  function getPersistedValue(key) {
    return getStoredItem("localStorage", key) || getCookie(key);
  }

  function getConfiguredCountryCode(countryCode) {
    return config.countries[countryCode] ? countryCode : "DE";
  }

  function getCurrentStorefrontKey() {
    var host = (window.location.hostname || "").toLowerCase();

    if (
      host.indexOf("us.olivetreepeople.com") !== -1 ||
      host.indexOf("olive-tree-people-test.myshopify.com") !== -1 ||
      host.indexOf("shopifypreview.com") !== -1
    ) {
      return "us";
    }

    if (host.indexOf("ca.olivetreepeople.com") !== -1) {
      return "ca";
    }

    if (
      host.indexOf("olivetreepeople.com") !== -1 ||
      host.indexOf("oliveda-de-test.myshopify.com") !== -1
    ) {
      return "eu";
    }

    return "eu";
  }

  function getDefaultCountryForStorefront(storefrontKey) {
    var storefront = config.storefronts[storefrontKey] || config.storefronts.eu;
    return getConfiguredCountryCode(storefront.defaultCountry || "DE");
  }

  function getSelectionValue(selection) {
    return selection.countryCode + "|" + selection.languageCode;
  }

  function getPersistedSelection() {
    var countryCode = getPersistedValue(STORAGE_KEYS.destinationCountry);
    var country = config.countries[countryCode];
    if (!country) return null;

    return parseSelection(
      countryCode +
        "|" +
        (getPersistedValue(STORAGE_KEYS.language) || country.defaultLanguage),
    );
  }

  function getCurrentDestinationCountry() {
    var currentStorefrontKey = getCurrentStorefrontKey();
    var persistedSelection = getPersistedSelection();

    if (
      persistedSelection &&
      config.countries[persistedSelection.countryCode].storefront ===
        currentStorefrontKey
    ) {
      return persistedSelection.countryCode;
    }

    return getDefaultCountryForStorefront(currentStorefrontKey);
  }

  function getCountryLabel(countryCode) {
    var country = config.countries[countryCode];
    return country ? country.name : config.countries.DE.name;
  }

  function getStorefrontLanguage(country, languageCode) {
    var storefront = country && config.storefronts[country.storefront];
    return storefront && storefront.languages
      ? storefront.languages[languageCode]
      : null;
  }

  function getOptionLabel(countryCode, languageCode) {
    var country = config.countries[countryCode];
    var language = getStorefrontLanguage(country, languageCode);

    if (!country || !language) return "";

    if (MULTI_LANG_SELECTOR[countryCode]) {
      return country.name + " (" + languageCode + ") / " + country.currency;
    }
    return country.name + " / " + country.currency;
  }

  function getMessages(languageCode) {
    return config.messages[languageCode] || config.messages.en;
  }

  function getMessage(messages, key) {
    return (messages && messages[key]) || config.messages.en[key] || "";
  }

  function formatMessage(template, values) {
    return String(template || "").replace(
      /\{([a-zA-Z0-9_]+)\}/g,
      function (match, key) {
        return values[key] != null ? values[key] : match;
      },
    );
  }

  function getLanguagePrefixes() {
    var prefixes = [];

    Object.keys(config.storefronts).forEach(function (storefrontKey) {
      var storefront = config.storefronts[storefrontKey];
      Object.keys(storefront.languages || {}).forEach(function (languageKey) {
        if (prefixes.indexOf(languageKey) === -1) {
          prefixes.push(languageKey);
        }
      });
    });

    return prefixes;
  }

  function getContentPath(pathname) {
    var segments = (pathname || "/").split("/").filter(Boolean);
    var knownPrefixes = getLanguagePrefixes();

    while (
      segments.length > 0 &&
      knownPrefixes.indexOf(segments[0].toLowerCase()) !== -1
    ) {
      segments.shift();
    }

    return segments.length ? "/" + segments.join("/") : "/";
  }

  function buildPath(prefix, contentPath) {
    if (contentPath === "/") return prefix || "/";
    return prefix ? prefix + contentPath : contentPath;
  }

  function parseSelection(value) {
    var parts = String(value || "").split("|");
    var countryCode = getConfiguredCountryCode(parts[0]);
    var country = config.countries[countryCode];
    var languageCode = parts[1] || country.defaultLanguage;

    if (
      country.languages.indexOf(languageCode) === -1 ||
      !getStorefrontLanguage(country, languageCode)
    ) {
      languageCode = country.defaultLanguage;
    }

    return {
      countryCode: countryCode,
      languageCode: languageCode,
    };
  }

  function getCurrentStorefrontLanguageCode() {
    var storefront =
      config.storefronts[getCurrentStorefrontKey()] || config.storefronts.eu;
    var segments = (window.location.pathname || "/").split("/").filter(Boolean);
    var pathLanguage = segments.length ? segments[0].toLowerCase() : "";

    if (storefront.languages[pathLanguage]) {
      return pathLanguage;
    }

    return storefront.defaultLanguage;
  }

  function getCurrentLanguageCode(countryCode) {
    var normalizedCountryCode = getConfiguredCountryCode(countryCode);
    var country = config.countries[normalizedCountryCode];
    var activeLanguage = getCurrentStorefrontLanguageCode();

    if (
      country.languages.indexOf(activeLanguage) !== -1 &&
      getStorefrontLanguage(country, activeLanguage)
    ) {
      return activeLanguage;
    }

    return country.defaultLanguage;
  }

  function getCurrentSelectionValue() {
    var countryCode = getCurrentDestinationCountry();
    return countryCode + "|" + getCurrentLanguageCode(countryCode);
  }

  function getRoute(selectionValue) {
    var selection = parseSelection(selectionValue);
    var normalizedCountryCode = selection.countryCode;
    var country = config.countries[normalizedCountryCode];
    var storefront = config.storefronts[country.storefront];
    var language =
      selection.languageCode ||
      country.defaultLanguage ||
      storefront.defaultLanguage;
    var languageConfig = storefront.languages[language] || {};

    return {
      base: storefront.baseUrl,
      prefix: languageConfig.prefix || "",
      lang: language,
    };
  }

  function addTransferParams(url, selectionValue) {
    var selection = parseSelection(selectionValue);

    url.searchParams.set("otp_country", selection.countryCode);
    url.searchParams.set("otp_lang", selection.languageCode);
    url.searchParams.set("otp_location_saved", "1");
  }

  function buildDestinationUrl(
    selectionValue,
    sourceLocation,
    includeTransferParams,
  ) {
    var route = getRoute(selectionValue);
    var locationSource = sourceLocation || window.location;
    var finalUrl = new URL(route.base);

    finalUrl.pathname = buildPath(
      route.prefix,
      getContentPath(locationSource.pathname),
    );
    finalUrl.search = locationSource.search || "";
    finalUrl.hash = locationSource.hash || "";

    if (includeTransferParams) {
      addTransferParams(finalUrl, selectionValue);
    }

    return finalUrl.toString();
  }

  function persistSelection(selectionValue, options) {
    var selection = parseSelection(selectionValue);
    var normalizedSelectionValue = getSelectionValue(selection);

    setStoredItem(
      "localStorage",
      STORAGE_KEYS.destinationCountry,
      selection.countryCode,
    );
    setStoredItem(
      "localStorage",
      STORAGE_KEYS.language,
      selection.languageCode,
    );
    setStoredItem(
      "sessionStorage",
      STORAGE_KEYS.legacyLanguage,
      selection.languageCode,
    );
    setCookie(STORAGE_KEYS.destinationCountry, selection.countryCode, 180);
    setCookie(STORAGE_KEYS.language, selection.languageCode, 180);

    if (options && options.pendingArrival) {
      setStoredItem(
        "sessionStorage",
        STORAGE_KEYS.pendingArrival,
        normalizedSelectionValue,
      );
    }

    return normalizedSelectionValue;
  }

  function getTransferState(locationSource) {
    var source = locationSource || window.location;
    var search = source.search || "";
    var params = new URLSearchParams(search);
    var countryCode = params.get("otp_country");
    var languageCode = params.get("otp_lang");

    if (
      !countryCode &&
      !languageCode &&
      params.get("otp_location_saved") !== "1"
    )
      return null;
    if (!countryCode) return null;

    var selection = parseSelection(countryCode + "|" + (languageCode || ""));

    return {
      selectionValue: getSelectionValue(selection),
      shouldShowArrival: params.get("otp_location_saved") === "1",
    };
  }

  function removeTransferParamsFromUrl() {
    if (!window.history || typeof window.history.replaceState !== "function")
      return;

    try {
      var currentUrl = new URL(window.location.href);
      TRANSFER_PARAMS.forEach(function (paramName) {
        currentUrl.searchParams.delete(paramName);
      });
      window.history.replaceState(
        window.history.state,
        document.title,
        currentUrl.pathname + currentUrl.search + currentUrl.hash,
      );
    } catch (e) {}
  }

  function hydrateTransferParams() {
    var transferState = getTransferState(window.location);
    if (!transferState) return null;

    persistSelection(transferState.selectionValue);
    removeStoredItem("sessionStorage", STORAGE_KEYS.pendingArrival);
    removeTransferParamsFromUrl();

    return transferState;
  }

  function consumePendingArrivalSelection() {
    var selectionValue = getStoredItem(
      "sessionStorage",
      STORAGE_KEYS.pendingArrival,
    );
    if (!selectionValue) return "";

    removeStoredItem("sessionStorage", STORAGE_KEYS.pendingArrival);
    return getSelectionValue(parseSelection(selectionValue));
  }

  function acknowledgeArrival(selectionValue) {
    if (!selectionValue) return;

    setStoredItem(
      "localStorage",
      STORAGE_KEYS.acknowledgedArrival,
      getSelectionValue(parseSelection(selectionValue)),
    );
  }

  function formatShoppingMessages(selectionValue) {
    var selection = parseSelection(selectionValue);
    var country = config.countries[selection.countryCode];
    var delivery = country.delivery || {};
    var messages = getMessages(selection.languageCode);
    var values = {
      country: country.name,
    };
    var bullets = [];

    (delivery.lines || []).forEach(function (line) {
      var template = messages[line.type] || config.messages.en[line.type];

      if (template) {
        bullets.push(
          formatMessage(template, {
            amount: line.amountLabel || "",
            country: country.name,
            duration: line.duration || "",
            estimate: line.estimate || "",
            method: line.method || "",
            price: line.price || "",
            range: line.range || "",
            threshold: line.thresholdLabel || "",
          }),
        );
      }
    });

    return {
      bullets: bullets,
      returnPolicy: getMessage(messages, "returnPolicy"),
      title: formatMessage(messages.shoppingIn, values),
      welcome: messages.welcome || config.messages.en.welcome,
    };
  }

  function updateSummary(select, languageCode) {
    var modal = getModal(select);
    var component = modal ? null : getComponent(select);
    var summary =
      (modal || component) &&
      (modal || component).querySelector("[data-otp-location-summary]");
    var option = select && select.options[select.selectedIndex];
    var label = option && option.textContent;
    var messages = getMessages(
      languageCode || getCurrentStorefrontLanguageCode(),
    );

    if (summary && label) {
      summary.textContent = formatMessage(
        getMessage(messages, "locationSummary"),
        {
          selection: label,
        },
      );
    }
  }

  function updateInterfaceCopy(root, languageCode) {
    if (!root) return;

    var messages = getMessages(
      languageCode || getCurrentStorefrontLanguageCode(),
    );
    var modal =
      root.matches && root.matches("[data-otp-location-modal]")
        ? root
        : root.querySelector("[data-otp-location-modal]");
    var trigger = root.querySelector("[data-otp-location-open]");

    if (trigger)
      trigger.setAttribute(
        "aria-label",
        getMessage(messages, "locationSettings"),
      );
    if (!modal) return;

    var modalTitle = modal.querySelector("[data-otp-location-modal-title]");
    var selectorView = modal.querySelector("[data-otp-location-selector-view]");
    var closeButton = modal.querySelector("[data-otp-location-close]");
    var selectLabel = modal.querySelector("[data-otp-location-select-label]");
    var select = modal.querySelector("[data-otp-location-select]");
    var saveButton = modal.querySelector("[data-otp-location-save]");
    var continueButton = modal.querySelector(
      "[data-otp-location-arrival-continue]",
    );
    var changeButton = modal.querySelector(
      "[data-otp-location-arrival-change]",
    );

    modal.otpLocationSelectorTitle = getMessage(messages, "locationSettings");

    if (modalTitle && selectorView && !selectorView.hidden) {
      modalTitle.textContent = modal.otpLocationSelectorTitle;
    }

    if (closeButton)
      closeButton.setAttribute(
        "aria-label",
        getMessage(messages, "closeLocationSettings"),
      );
    if (selectLabel)
      selectLabel.setAttribute(
        "data-otp-location-select-label",
        getMessage(messages, "destinationCountry"),
      );
    if (select)
      select.setAttribute(
        "aria-label",
        getMessage(messages, "destinationCountry"),
      );
    if (saveButton) saveButton.textContent = getMessage(messages, "save");
    if (continueButton)
      continueButton.textContent = getMessage(messages, "continueShopping");
    if (changeButton)
      changeButton.textContent = getMessage(messages, "changeShippingCountry");
  }

  function updateTriggerCode(component, countryCode) {
    var code =
      component && component.querySelector("[data-otp-location-current-code]");
    if (code) code.textContent = countryCode;
  }

  function setModalView(modal, viewName) {
    var selectorView =
      modal && modal.querySelector("[data-otp-location-selector-view]");
    var arrivalView =
      modal && modal.querySelector("[data-otp-location-arrival-view]");
    var modalTitle =
      modal && modal.querySelector("[data-otp-location-modal-title]");
    var showArrival = viewName === "arrival";

    if (selectorView) selectorView.hidden = showArrival;
    if (arrivalView) arrivalView.hidden = !showArrival;
    if (modalTitle) {
      modalTitle.textContent = showArrival
        ? modal.otpLocationArrivalWelcome || config.messages.en.welcome
        : modal.otpLocationSelectorTitle || config.messages.en.locationSettings;
    }
  }

  function renderArrivalView(modal, selectionValue) {
    var selection = parseSelection(selectionValue);
    var messageSet = formatShoppingMessages(selectionValue);
    var title =
      modal && modal.querySelector("[data-otp-location-arrival-title]");
    var list = modal && modal.querySelector("[data-otp-location-arrival-list]");
    var returnPolicy =
      modal && modal.querySelector("[data-otp-location-return-policy]");

    updateInterfaceCopy(modal, selection.languageCode);
    if (title) title.textContent = messageSet.title;
    if (returnPolicy) returnPolicy.textContent = messageSet.returnPolicy;

    if (list) {
      list.innerHTML = "";
      messageSet.bullets.forEach(function (message) {
        var item = document.createElement("li");
        item.textContent = message;
        list.appendChild(item);
      });
    }

    if (modal) {
      modal.otpLocationArrivalSelection = getSelectionValue(selection);
      modal.otpLocationArrivalWelcome = messageSet.welcome;
    }
  }

  function getPreferredComponent() {
    var components = Array.prototype.slice.call(
      document.querySelectorAll(".otp-location-settings"),
    );

    return (
      components.find(function (component) {
        return (
          component.getClientRects && component.getClientRects().length > 0
        );
      }) ||
      components[0] ||
      null
    );
  }

  function renderSelect(select) {
    var currentSelectionValue = getCurrentSelectionValue();

    select.innerHTML = "";

    config.groups.forEach(function (group) {
      var optgroup = document.createElement("optgroup");
      optgroup.label = group.label;

      group.countries.forEach(function (countryCode) {
        var country = config.countries[countryCode];
        if (!country) return;

        var displayLanguages = MULTI_LANG_SELECTOR[countryCode]
          ? MULTI_LANG_SELECTOR[countryCode]
          : [country.defaultLanguage];

        displayLanguages.forEach(function (languageCode) {
          var language = getStorefrontLanguage(country, languageCode);
          if (!language) return;

          var option = document.createElement("option");
          option.value = countryCode + "|" + languageCode;
          option.textContent = getOptionLabel(countryCode, languageCode);
          option.setAttribute("data-country-code", countryCode);
          option.setAttribute("data-country-label", country.name);
          option.setAttribute("data-language-code", languageCode);

          if (option.value === currentSelectionValue) {
            option.selected = true;
          }

          optgroup.appendChild(option);
        });
      });

      select.appendChild(optgroup);
    });

    updateSummary(select, getCurrentStorefrontLanguageCode());
  }

  function prepareSelectorView(modal) {
    if (!modal) return;

    var activeLanguage = getCurrentStorefrontLanguageCode();
    var select = modal.querySelector("[data-otp-location-select]");

    updateInterfaceCopy(modal, activeLanguage);
    if (select) renderSelect(select);
  }

  function renderComponents() {
    var currentCountry = getCurrentDestinationCountry();
    var activeLanguage = getCurrentStorefrontLanguageCode();

    document
      .querySelectorAll(".otp-location-settings")
      .forEach(function (component) {
        updateTriggerCode(component, currentCountry);
        updateInterfaceCopy(component, activeLanguage);
        component
          .querySelectorAll("[data-otp-location-select]")
          .forEach(renderSelect);
      });
  }

  function showArrivalDialog(selectionValue) {
    var component = getPreferredComponent();
    var modal = getComponentModal(component);
    if (!component || !modal) return;

    renderArrivalView(modal, selectionValue);
    openModal(component, null, "arrival");
  }

  function openModal(component, trigger, viewName) {
    var modal = getComponentModal(component);
    if (!modal) return;

    if (activeModal && activeModal !== modal) closeModal();

    if (viewName !== "arrival") {
      prepareSelectorView(modal);
    }

    setModalView(modal, viewName || "selector");
    returnFocusTo = trigger || document.activeElement;
    activeModal = modal;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add("is-visible");
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("otp-location-settings-open");

    if (trigger) trigger.setAttribute("aria-expanded", "true");

    var focusTarget =
      viewName === "arrival"
        ? modal.querySelector("[data-otp-location-arrival-title]")
        : modal.querySelector("[data-otp-location-close]");

    if (focusTarget) focusTarget.focus();
  }

  function closeModal() {
    if (!activeModal) return;

    var component =
      activeModal.otpLocationComponent || getComponent(activeModal);
    var trigger =
      returnFocusTo ||
      (component && component.querySelector("[data-otp-location-open]"));

    activeModal.classList.remove("is-visible");
    activeModal.classList.remove("is-open");
    activeModal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("otp-location-settings-open");

    if (
      trigger &&
      trigger.matches &&
      trigger.matches("[data-otp-location-open]")
    ) {
      trigger.setAttribute("aria-expanded", "false");
    }

    if (returnFocusTo && typeof returnFocusTo.focus === "function") {
      returnFocusTo.focus();
    }

    activeModal = null;
    returnFocusTo = null;
  }

  function redirectToSelection(selectionValue) {
    var route = getRoute(selectionValue);
    var normalizedSelectionValue = persistSelection(selectionValue);

    setStoredItem("sessionStorage", STORAGE_KEYS.legacyLanguage, route.lang);
    window.location.href = buildDestinationUrl(
      normalizedSelectionValue,
      window.location,
      true,
    );
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    document.addEventListener("click", function (event) {
      var openTrigger = event.target.closest("[data-otp-location-open]");
      if (openTrigger) {
        event.preventDefault();
        openModal(getComponent(openTrigger), openTrigger, "selector");
        return;
      }

      if (event.target.closest("[data-otp-location-arrival-continue]")) {
        event.preventDefault();
        var continueModal = getModal(event.target);
        acknowledgeArrival(
          continueModal && continueModal.otpLocationArrivalSelection,
        );
        closeModal();
        return;
      }

      if (event.target.closest("[data-otp-location-arrival-change]")) {
        event.preventDefault();
        var arrivalModal = getModal(event.target);
        prepareSelectorView(arrivalModal);
        setModalView(arrivalModal, "selector");

        var select =
          arrivalModal &&
          arrivalModal.querySelector("[data-otp-location-select]");
        if (select && typeof select.focus === "function") select.focus();

        return;
      }

      if (event.target.closest("[data-otp-location-close]")) {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.target.matches("[data-otp-location-modal]")) {
        closeModal();
      }
    });

    document.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-otp-location-form]");
      if (!form) return;

      event.preventDefault();
      var select = form.querySelector("[data-otp-location-select]");
      if (select) redirectToSelection(select.value);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeModal();
    });
  }

  function init() {
    var transferState = hydrateTransferParams();
    var arrivalSelection =
      transferState && transferState.shouldShowArrival
        ? transferState.selectionValue
        : consumePendingArrivalSelection();

    renderComponents();
    bindEvents();

    if (arrivalSelection) showArrivalDialog(arrivalSelection);
  }

  window.OTP_LOCATION_SETTINGS = {
    buildDestinationUrl: buildDestinationUrl,
    formatShoppingMessages: formatShoppingMessages,
    getContentPath: getContentPath,
    getCurrentDestinationCountry: getCurrentDestinationCountry,
    getCurrentSelectionValue: getCurrentSelectionValue,
    getCurrentStorefrontKey: getCurrentStorefrontKey,
    getCurrentStorefrontLanguageCode: getCurrentStorefrontLanguageCode,
    getPersistedSelection: getPersistedSelection,
    getRoute: getRoute,
    getTransferState: getTransferState,
    hydrateTransferParams: hydrateTransferParams,
    init: init,
    parseSelection: parseSelection,
    persistSelection: persistSelection,
    renderComponents: renderComponents,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
